// @flow
const uploadingViewStyles = {
  container: (theme: Object) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(3),
    width: '100%',
    maxWidth: 500,
    margin: '0 auto'
  }),

  content: (theme: Object) => ({
    width: '100%',
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`
  }),

  header: (theme: Object) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(2)
  }),

  spinner: (theme: Object) => ({
    color: theme.palette.primary.main
  }),

  title: (theme: Object) => ({
    fontWeight: 500,
    color: theme.palette.text.primary
  }),

  fileInfo: (theme: Object) => ({
    marginBottom: theme.spacing(3),
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.shape.borderRadius
  }),

  fileName: (theme: Object) => ({
    fontWeight: 500,
    color: theme.palette.text.primary,
    wordBreak: 'break-all'
  }),

  fileSize: (theme: Object) => ({
    color: theme.palette.text.secondary
  }),

  progressContainer: (theme: Object) => ({
    marginBottom: theme.spacing(3)
  }),

  progressBar: (theme: Object) => ({
    height: 8,
    borderRadius: 4,
    backgroundColor: theme.palette.divider,
    '& .MuiLinearProgress-bar': {
      borderRadius: 4,
      backgroundColor: theme.palette.primary.main
    }
  }),

  progressInfo: (theme: Object) => ({
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(1)
  }),

  statusText: (theme: Object) => ({
    color: theme.palette.text.secondary
  }),

  progressPercent: (theme: Object) => ({
    fontWeight: 500,
    color: theme.palette.primary.main
  }),

  stages: (theme: Object) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1)
  }),

  stage: (theme: Object) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    '& .MuiTypography-root': {
      color: theme.palette.text.disabled,
      fontSize: '0.75rem'
    }
  }),

  stageActive: (theme: Object) => ({
    '& .MuiTypography-root': {
      color: theme.palette.primary.main,
      fontWeight: 500
    }
  }),

  stageComplete: (theme: Object) => ({
    '& .MuiTypography-root': {
      color: theme.palette.success.main
    }
  }),

  stageDot: (theme: Object) => ({
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: theme.palette.divider,
    '$stageActive &': {
      backgroundColor: theme.palette.primary.main
    },
    '$stageComplete &': {
      backgroundColor: theme.palette.success.main
    }
  }),

  stageLine: (theme: Object) => ({
    width: 40,
    height: 2,
    backgroundColor: theme.palette.divider,
    marginTop: -12
  }),

  actions: (theme: Object) => ({
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    marginTop: theme.spacing(3)
  })
};

export default uploadingViewStyles;
